import {Head, useForm} from '@inertiajs/react'
import Layout from "../../components/layout";
import {ArrowRightIcon} from '@heroicons/react/24/solid/index.js';
import {useCallback, useEffect} from 'react';
import colors from '../../colors.js';
import toast from 'react-hot-toast';

export default function VerifyEmail({validateUrl, email, code = null}) {
    const {data, setData, post, processing, errors} = useForm({
        email: email,
        code: code,
    })

    useEffect(() => {
        toast.success('We have just emailed you a verification code. Please enter it down below.')
    }, []);

    const logInAsGuest = useCallback(() => {
        post(validateUrl);
    }, [data.email, data.code]);

    return (<Layout>
        <Head title={"Log in"}/>
        <div className="relative h-full">
            <div
                className="flex full-screen flex-col grow bg-linear-to-b from-transparent via-transparent to-black px-[20px] pb-[20px]">
                <div className="flex grow flex-col items-center justify-center">
                    <div className="w-full">

                        <div>
                            <label className="text-white-foreground font-bold" htmlFor="code">Verification code</label>
                            <input
                                required
                                autoFocus={true}
                                id="code"
                                placeholder={'XXXXX'}
                                className="w-full border-[0.5px] py-4 px-6 rounded-[25px] text-white-foreground"
                                style={{
                                    backgroundColor: colors.backdropBackground,
                                    borderColor: colors.borderBottomColor,
                                }}
                                type="number"
                                autoComplete="one-time-code"
                                value={data.code}
                                onChange={e => setData('code', e.target.value)}
                            />
                            <div>
                                {errors.code && <small className="text-red-500">{errors.code}</small>}
                            </div>
                            <small className="text-white-foreground">We have to verify your email to continue.</small>
                        </div>
                        <button
                            className="flex-wrap w-full shadow-sm transition duration-300 transform px-6 py-3 font-medium text-white-foreground mt-[10px] primary-camera-button/80 focus:bg-primary-500/80 text-center flex flex-row items-center justify-center"
                            type="button"
                            disabled={processing}
                            onClick={logInAsGuest}>
                            Verify <ArrowRightIcon className="w-4 h-4 text-white-foreground ml-2"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Layout>)
}
